import JustificationTable from "./JustificationTable"
import LoadingTable       from '../Table/LoadingTable.js'
import axios              from 'axios';
import api				  from '../../services/api';
import { useContext, useEffect, useState }                from 'react';
import { useJustificationPage, JustificationPageContext } from '../../contexts/JustificationPageContext';

export default function JustificationTableContainer() {
    
    const { 
        selectedComparisionId, 
        isJustificationModalOpen, 
        justificationList 
    } = useContext(JustificationPageContext)
 
    const { 

        updateJustificationTable,   
        handleSetComparisionData, 
        handleSetComparisionList, 
        handleSetSelectedJustificationId,
        handerOpenJustificationForm, 
        handlerSetJustificationFormEditMode,
        handleUpadeComparisionTable
        
    } = useJustificationPage()

    const [loading, isLoading] = useState(true)

    const fetchJustifications = async () => {
            
        try {

            const response = await api.get(`/getJustificationsByComparisionId/${selectedComparisionId}`);
            handleSetComparisionList(response.data.justifications);
            handleSetComparisionData(response.data.comparision);

        } catch (error) {
            console.error("Error fetching justifications: ", error);
        }

        isLoading(false)

    };

    const handleDeleteJustification = async (justificationId) => {
        try {
            await api.delete(`/deleteJustification/${justificationId}`);
            fetchJustifications()
            handleUpadeComparisionTable()
        } catch (error) {
            console.error("Error deleting justification: ", error);
        }
    };

    const handleEditJustification = (justificationId) => {
        handleSetSelectedJustificationId(justificationId)
        handerOpenJustificationForm()
        handlerSetJustificationFormEditMode(true)
    };

    useEffect(() => {
        try {
            fetchJustifications();
            isLoading(true)
        }
        catch (error) {
            console.error("Error fetching justifications: ", error);
        }
    }, [isJustificationModalOpen, updateJustificationTable])
    
    return (
    <>{ loading ? (

        <table className='table-pattern-sistem w-[100%] borda-cinza mt-[15px]'>
            <thead className='bg-neutro'>
                <tr>
                    <th><div className='one h-[15px] w-[50px] bg-neutro rounded-[12px]'> </div></th>
                    <th><div className='one h-[15px] w-[130px] bg-neutro rounded-[12px]'> </div></th>
                    <th><div className='one h-[15px] w-[80px] bg-neutro rounded-[12px]'> </div></th>
                    <th><div className='one h-[15px] w-[130px] bg-neutro rounded-[12px]'> </div></th>
                    <th><div className='one h-[15px] w-[100px] bg-neutro rounded-[12px]'> </div></th>
                </tr>

            </thead>

            <tbody>
                <tr className='row hover:cursor-pointer hover:bg-neutro'>
                    <td> <div className='two h-[15px] w-[30px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[110px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[60px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[110px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[80px] bg-neutro rounded-[12px]'> </div> </td>
                </tr>
                <tr className='row hover:cursor-pointer hover:bg-neutro'>
                    <td> <div className='one h-[15px] w-[50px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[130px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[80px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[130px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[100px] bg-neutro rounded-[12px]'> </div> </td>
                </tr>
                <tr className='row hover:cursor-pointer hover:bg-neutro'>
                    <td> <div className='two h-[15px] w-[30px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[110px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[60px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[110px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[80px] bg-neutro rounded-[12px]'> </div> </td>
                </tr>

            </tbody>
        </table>
        
        
    ) : (
  
        <JustificationTable 
            tableRows={justificationList} 
            onEditRow={handleEditJustification}
            onDeleteRow={handleDeleteJustification}
        />
        
    )}
        
    </>
    )
}